/**
 * How the Adopt Dictionary button looks. One state: enabled.
 *
 * IT USED TO ASK THE SERVER FIRST. The page called
 * getDictionaryAdoptionEligibilityV2 and disabled the button until it answered.
 * Since decision 7 (2026-09-15) that question has only one answer - adoption is
 * never refused because documents already exist - so the call could only ever
 * say yes, while costing the button real availability: the callable is rarely
 * invoked, so it usually meets a cold start and the button sat disabled for
 * seconds after the page had settled, and a check that FAILED disabled it
 * altogether. A control that can only say yes must not be able to say no by
 * timing out.
 *
 * The callable and its server code stay deployed and are still the authority
 * the apply re-reads; nothing in the browser calls them any more.
 *
 * Kept as a function rather than inlined so the tooltip copy has one home and
 * one test. Pure - `web` has no test runner of its own; see
 * adoptButtonState.test.ts.
 */

export interface AdoptButtonView {
  /** The slot is part of the card, not a consequence of any answer. */
  reserved: true;
  /** Always true: nothing can take this button away. */
  enabled: true;
  /** Always false: there is nothing left to wait for. */
  loading: false;
  label: string;
  title: string;
}

export const ADOPT_BUTTON_LABEL = 'Adopt Dictionary as Source of Truth';

export const ADOPT_BUTTON_TITLE =
  "Upload a DocumentSpark data dictionary from another project. This project's forms and " +
  'stored data dictionary are made to match it; an SDTM mapping, edit checks or annotated ' +
  'CRF already generated are marked out of date, and any renamed variable is listed on their ' +
  'notice with your choices. This is not the ' +
  "CRF Builder's REDCap Import DD, and not Apply Dictionary Edits.";

export function adoptButtonState(): AdoptButtonView {
  return {
    reserved: true,
    enabled: true,
    loading: false,
    label: ADOPT_BUTTON_LABEL,
    title: ADOPT_BUTTON_TITLE,
  };
}
